/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_SURVEYS_REQUEST]: state => {
    state.loadingSurveys = true;
    state.loadingSurveysFailed = false;
  },

  [types.GET_SURVEYS_FAILURE]: (state, error) => {
    state.loadingSurveys = false;
    state.loadingSurveysFailed = true;
    state.loadingSurveysError = error;
  },

  [types.GET_SURVEYS_SUCCESS]: (state, response) => {
    state.loadingSurveys = false;
    state.surveys = response.data;
    state.loadingSurveysFailed = false;
  },

  [types.GET_SURVEY_CHARTS_REQUEST]: state => {
    state.loadingCharts = true;
    state.loadingChartsFailed = false;
    state.loadingChartsSucceeded = false;
  },

  [types.GET_SURVEY_CHARTS_FAILURE]: (state, error) => {
    state.loadingCharts = false;
    state.loadingChartsFailed = true;
    state.loadingChartsError = error;
    state.loadingChartsSucceeded = false;
  },

  [types.GET_SURVEY_CHARTS_SUCCESS]: (state, response) => {
    state.loadingCharts = false;
    state.loadingChartsSucceeded = true;
    state.chartsData = response.data;
    state.loadingChartsFailed = false;
  },

  [types.CLEAR_SURVEY_CHARTS]: state => {
    state.chartsData = [];
  },

  [types.GET_PERIODS_REQUEST]: state => {
    state.loadingPeriods = true;
    state.loadingPeriodsFailed = false;
  },

  [types.GET_PERIODS_FAILURE]: (state, error) => {
    state.loadingPeriods = false;
    state.loadingPeriodsFailed = true;
    state.loadingPeriodsError = error;
  },

  [types.GET_PERIODS_SUCCESS]: (state, response) => {
    state.loadingPeriods = false;
    state.periods = response.data;
    state.loadingPeriodsFailed = false;
  },

  [types.GET_SURVEY_ANSWER_GROUPS_REQUEST]: state => {
    state.loadingPeriods = true;
    state.loadingPeriodsFailed = false;
  },

  [types.GET_SURVEY_ANSWER_GROUPS_FAILURE]: (state, error) => {
    state.loadingPeriods = false;
    state.loadingPeriodsFailed = true;
    state.loadingPeriodsError = error;
  },

  [types.GET_SURVEY_ANSWER_GROUPS_SUCCESS]: (state, response) => {
    state.loadingPeriods = false;
    state.periods = response.data;
    state.loadingPeriodsFailed = false;
  },

  [types.GET_SPOT_CHARTS_REQUEST]: state => {
    state.loadingSpotCharts = true;
    state.loadingSpotChartsFailed = false;
    state.loadingSpotChartsSucceeded = false;
  },

  [types.GET_SPOT_CHARTS_FAILURE]: (state, error) => {
    state.loadingSpotCharts = false;
    state.loadingSpotChartsFailed = true;
    state.loadingSpotChartsError = error;
    state.loadingSpotChartsSucceeded = false;
  },

  [types.GET_SPOT_CHARTS_SUCCESS]: (state, response) => {
    state.loadingSportCharts = false;
    state.loadingSpotChartsSucceeded = true;
    state.spotChartsData = response.data;
    state.loadingSpotChartsFailed = false;
  },

  [types.CLEAR_SURVEY_CHARTS]: state => {
    state.spotChartsData = [];
  },

  [types.CREATE_SPOT_REQUEST]: state => {
    state.creatingSpot = true;
    state.creatingSpotSucceeded = false;
    state.creatingSpotFailed = false;
  },

  [types.CREATE_SPOT_SUCCESS]: (state, response) => {
    state.creatingSpot = false;
    state.creatingSpotSucceeded = true;
    state.chartsData.append(response.data);
  },

  [types.CREATE_SPOT_FAILURE]: (state, error) => {
    state.creatingSpot = false;
    state.creatingSpotFailed = true;
    state.creatingSpotError = error;
  },

  [types.GET_SURVEY_DEMOGRAPHICS_REQUEST]: state => {
    state.loadingDemographics = true;
    state.loadingDemographicsSucceeded = false;
    state.loadingDemographicsFailed = false;
  },

  [types.GET_SURVEY_DEMOGRAPHICS_SUCCESS]: (state, response) => {
    state.demographics = response;
    state.loadingDemographicsSucceeded = true;
    state.loadingDemographics = false;
  },

  [types.GET_SURVEY_DEMOGRAPHICS_FAILURE]: (state, error) => {
    state.loadingDemographicsFailed = true;
    state.loadingDemographicsSucceeded = false;
    state.loadingDemographicsError = error;
  },

  [types.GET_SURVEY_RESPONDENTS_REQUEST]: state => {
    state.loadingRespondents = true;
    state.loadingRespondentsSucceeded = false;
    state.loadingRespondentsFailed = false;
  },

  [types.GET_SURVEY_RESPONDENTS_SUCCESS]: (state, response) => {
    state.respondents = [...state.respondents, ...response.entries];
    state.respondentCount = response.totalPages;
    state.respondentPageInfo = { totalPages: response.totalPages, pageNumber: response.pageNumber };

    state.loadingRespondents = false;
    state.loadingRespondentsSucceeded = true;
    state.loadingRespondentsFailed = false;

    if (response.pageNumber <= response.totalPages) {
      state.respondentMoreUrl = response.pageNumber + 1;
    } else {
      state.respondentMoreUrl = null;
    }
  },

  [types.GET_SURVEY_RESPONDENTS_FAILURE]: (state, error) => {
    state.loadingRespondents = false;
    state.loadingRespondentsFailed = true;
    state.loadingRespondentsSucceeded = false;
    state.loadingRespondentsError = error;
  },

  [types.CLEAR_SURVEY_RESPONDENTS]: state => {
    state.respondents = [];
    state.respondentCount = 0;
    state.respondentMoreUrl = null;
  },

  [types.DOWNLOAD_SURVEY_RESPONSES_REQUEST]: state => {
    state.downloadingResponses = true;
    state.downloadingResponsesFailed = false;
    state.downloadingResponsesSucceeded = false;
    state.downloadingResponsesError = false;
  },

  [types.DOWNLOAD_SURVEY_RESPONSES_SUCCESS]: state => {
    state.downloadingResponses = false;
    state.downloadingResponsesFailed = false;
    state.downloadingResponsesSucceeded = true;
    state.downloadingResponsesError = false;
  },

  [types.DOWNLOAD_SURVEY_RESPONSES_FAILURE]: (state, error) => {
    state.downloadingResponses = false;
    state.downloadingResponsesFailed = true;
    state.downloadingResponsesSucceeded = true;
    state.downloadingResponsesError = error;
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/survey/mutations.js